<template>
  <div class="teacherControl">
    <div class="header">
      <el-button
        @click="switchPage('activity','define')"
        :type="pageList.activity.define? 'primary': ''"
      >活动</el-button>
      <el-button
        @click="declare('declare', 'show')"
        :type="pageList.declare.show || pageList.declare.define? 'primary': ''"
      >申报</el-button>
    </div>
    <div class="content" v-show="pageList.declare.show || pageList.declare.define">
      <div class="select">
        <el-button type="primary" @click="newDeclareDefine('declare','define')" :disabled="declareShow">新增申报</el-button>
        <el-input placeholder="申报名称快速检索" v-model="declareValue"></el-input>
      </div>
      <div class="select-content">
        <div
          class="activityItem"
          v-for="(declareItem,key) in declareList"
          :key="key"
          @click="goDeclareShow(key)"
        >
          <span :class="declareItem.change? 'active': ''">{{declareItem.name}}</span>
        </div>
        <img v-show="showNoData" src="../../assets/image/studyMonitor/noData.png" alt="" style="zoom: 28%">
      </div>
    </div>
    <div class="content" v-show="pageList.activity.define">
      <div class="select">
        <el-button type="primary" @click="newActivity('activity','define')" :disabled="activityShow">新增活动</el-button>
        <el-input v-model="activityValue" placeholder="活动名称快速检索"></el-input>
      </div>
      <div class="select-content">
        <div
          class="activityItem"
          v-for="(activityItem,key) in copyList"
          @click="goActivityClick(activityItem.id,key)"
          :key="key"
        >
          <span
            :class="activityItem.publish? 'open': 'close'"
          >{{activityItem.publish ? '已发布': '未发布'}}</span>
          <span :class="activityItem.change? 'active': ''">{{activityItem.name}}</span>
        </div>
        <img v-show="isShowActivity" src="../../assets/image/studyMonitor/noData.png" alt="" style="zoom: 28%">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "teacherControl",
  data() {
    return {
      pageList: {
        activity: {
          define: true
        },
        declare: {
          show: false,
          define: false
        }
      },
      activityList: [], // 检索到的活动数据
      declareList: [], // 检索到的申报数据
      oldActivityList: [],
      activityValue: "",
      declareValue: "",
      oldDeclareList: [],
      activityKey: 0,
      declareKey: 0,
      activityShow:false, // 活动按钮禁用
      declareShow:false,  // 申报按钮禁用
      isShowActivity:false, // 显示活动页面的无数据占位图
      isShowDeclare:false,
      activityIndex:'', // 当前选中活动的index
      isLeave:true, // 是否离开新建页面
      copyList:[], // 用于活动页页面渲染
      showNoData: false, //检测有无数据
      nextKey:''
    };
  },
  props: {
    getNotice: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    activityValue: {
      // 这里的copyList为原先的activityList
      handler(newVal) {
        if (newVal.length === 0) {
          this.copyList = this.oldActivityList;
          this.activityList = this.oldActivityList;
          if(this.activityList.length !== 0){
            this.isShowActivity = false;
          }
        } else {
          this.activityList = [];
          this.oldActivityList.forEach(item => {
            if (item.name.search(newVal) !== -1) {
              this.activityList.push(item);
            }
          });
          this.copyList = this.activityList;
          if(this.copyList.length === 0){
            this.isShowActivity = true;
          }else {
            this.isShowActivity = false;
          }
        }
      },
      deep: true
    },
    declareValue: {
      handler(newVal) {
        this.declareList = [];
        if (newVal.length === 0) {
          this.declareList = this.oldDeclareList;
        } else {
          this.oldDeclareList.forEach(item => {
            if (item.name.search(newVal) !== -1) {
              this.declareList.push(item);
            }
          });
        }
      },
      deep: true
    },
    monitoring: {
      handler(newVal) {
        // 保存后数据更新
        if (this.$route.path === "/activityDefine") {
          this.activityList = [];
          this.getAllActivityDefine(
            "/api/blog/eRate/getAllActivityDefine",
            this.activityList
          ).then(res => {
            if (this.activityList.length > 0 && this.$store.state.deleteState && this.activityList.length === (this.activityIndex + 1)) {
              this.goActivity(this.activityList[0].id, 0);
              this.$store.state.deleteState = false;
            } else if (this.activityList.length > 0 && this.$store.state.deleteState){
              this.goActivity(this.activityList[this.activityIndex].id, this.activityIndex);
              this.$store.state.deleteState = false;
            } else {
              this.goActivity(this.activityList[this.activityIndex].id, this.activityIndex);
            }
          });
        }
      }
    },
    // monitoring: {
    //   handler(newVal) {
    //     // 保存后数据更新
    //     if (this.$route.path === "/activityDefine") {
    //       this.activityList = [];
    //       this.getAllActivityDefine(
    //               "/api/blog/eRate/getAllActivityDefine",
    //               this.activityList
    //       ).then(res => {
    //         if (this.activityList.length > 0) {
    //           this.goActivity(this.activityList[0].id, 0);
    //         }
    //       });
    //     }
    //   }
    // },
    declareState: {
      async handler(newVal) {
        this.declareList = [];
        await this.getAllDeclareDefine(
          "/api/blog/eRate/getAllDeclareDefine",
          this.declareList
        );
        if(this.nextKey === this.declareList.length){
          this.goDeclareShow(0)
        } else {
          this.goDeclareShow(this.nextKey)
        }
      },
      deep: true
    },
    copyList:function (value) {
      if(value === ''){
        this.activityShow = true
        this.$router.push({
          path: "/activityDefine"
        });
        this.newDeclareDefine()
      }else {
        this.activityShow = false;
      }
    },
    declareList:function (value) {
      if(value === ''){
        this.declareShow = true
        this.$router.push({
          path: "/declareDefine"
        });
      }else {
        this.activityShow = false
      }
    },
  },
  computed: {
    monitoring() {
      return this.$store.state.monitoring;
    },
    declareState() {
      return this.$store.state.declareState;
    }
  },
  created() {
    // this.$https.post('/api/blog/eRate/clear')
    this.activityList = [];
    if (
      this.$route.path === "/declareShow" ||
      this.$route.path === "/declareDefine"
    ) {
      this.switchPage("declare", "show");
    }
    if(this.copyList.length === 0){
      this.getAllActivityDefine(
              "/api/blog/eRate/getAllActivityDefine",
              this.activityList
      ).then(res => {
        if (this.activityList.length > 0) {
          this.goActivity(this.activityList[0].id, 0);
        }
      });
    }
    // this.copyList = this.activityList
  },
  methods: {
    // 活动|申报点击加载
    switchPage(pageNum, childPage) {
      this.activityValue = '';
      this.declareValue = '';
      setTimeout(() => {
        document.activeElement.blur();
      }, 500);

      if (!this.pageList[pageNum][childPage]) {
        // 展示申报
        this.setFalse(this.pageList);
        this.$store.dispatch("contentChangeDeclareId", "");
        this.pageList[pageNum][childPage] = !this.pageList[pageNum][childPage];
        this.declareList = [];
        if (pageNum === "activity") {
          this.$router.push({
            path: "/activityDefine"
          });
          this.$store.dispatch("contentChangeActivityId", "");
          this.activityList = [];
          this.getAllActivityDefine(
            "/api/blog/eRate/getAllActivityDefine",
            this.activityList
          ).then(res => {
            if (this.activityList.length > 0) {
              this.goActivity(this.activityList[0].id, 0);
            }
          });
          return;
        }
        this.getAllDeclareDefine(
          "/api/blog/eRate/getAllDeclareDefine",
          this.declareList
        ).then(() => {
          this.oldDeclareList = this.declareList;
          if(this.oldDeclareList.length){
            this.showNoData = false
          } else {
            this.showNoData = true
          }
          if (this.declareList.length === 0) {
            this.$router.push({
              path: "/declareDefine",
              query: {
                id: ""
              }
            });
            return;
          }
          if (pageNum === "declare") {  //在这里
            if(this.$route.path === '/declareShow'){
              this.$router.push({
                path: "/declareShow",
                query: {
                  id: this.declareList[0].id
                }
              });
            } else {
              this.$router.push({
                path: "/declareDefine"
              });
            }
          }
          this.$store.dispatch(
            "contentChangeDeclareId",
            this.declareList[0].id
          );
          this.declareList[0].change = true;
          // 路由判断
          if(this.$route.path === '/declareDefine'){
            if(this.declareList !== ''){
              this.$router.push({
                path: "/declareShow",
                query: {
                  id: this.declareList[0].id
                }
              });
            }else {
              this.$router.push({
                path: "/declareDefine",
              });
            }
          }
          // if (this.$route.path !== "/activityDefine") {
          //   this.$router.push({
          //     path: "/declareShow",
          //     query: {
          //       id: this.declareList[0].id
          //     }
          //   });
          // }
        });
      }
      if (this.pageList.activity.define) {
        this.$store.dispatch("contentChangeActivityId", "");
        this.$router.push({
          path: "/activityDefine"
        });
        this.activityList = [];
        this.getAllActivityDefine(
          "/api/blog/eRate/getAllActivityDefine",
          this.activityList
        );
        return;
      }
      if (this.pageList.declare.define) {
        this.$router.push({
          path: "/declareDefine"
        });
        this.declareList = [];
        return;
      }
      this.activityList = [];
    },
    newActivity(pageNum, childPage) {
      // this.isLeave = false;
      this.$store.state.isLeave = false;
      if (this.pageList.activity.define) {
        this.$store.dispatch("contentChangeActivityId", "");
        this.$router.push({
          path: "/activityDefine"
        });
        this.activityList = [];
        this.getAllActivityDefine(
                "/api/blog/eRate/getAllActivityDefine",
                this.activityList
        );
        return;
      }
      this.activityList = [];
    },
    declare(pageNum, childPage) {
      if(!this.$store.state.isLeave){
        this.$confirm('确定离开此页面?离开内容不会保存', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.activityValue = '';
          this.declareValue = '';
          setTimeout(() => {
            document.activeElement.blur();
          }, 500);

          if (!this.pageList[pageNum][childPage]) {
            // 展示申报
            this.setFalse(this.pageList);
            this.$store.dispatch("contentChangeDeclareId", "");
            this.pageList[pageNum][childPage] = !this.pageList[pageNum][childPage];
            this.declareList = [];
            if (pageNum === "declare") {
              this.$router.push({
                path: "/declareDefine"
              });
            }
            if (pageNum === "activity") {
              this.$router.push({
                path: "/activityDefine"
              });
              this.$store.dispatch("contentChangeActivityId", "");
              this.activityList = [];
              this.getAllActivityDefine(
                      "/api/blog/eRate/getAllActivityDefine",
                      this.activityList
              ).then(res => {
                if (this.activityList.length > 0) {
                  this.goActivity(this.activityList[0].id, 0);
                }
              });
              return;
            }
            this.getAllDeclareDefine(
                    "/api/blog/eRate/getAllDeclareDefine",
                    this.declareList
            ).then(() => {
              this.oldDeclareList = this.declareList;
              if(this.oldDeclareList.length){
                this.showNoData = false
              } else {
                this.showNoData = true
              }
              if (this.declareList.length === 0) {
                this.$router.push({
                  path: "/declareDefine",
                  query: {
                    id: ""
                  }
                });
                return;
              }
              this.$store.dispatch(
                      "contentChangeDeclareId",
                      this.declareList[0].id
              );
              this.declareList[0].change = true;
              // 路由判断
              if(this.$route.path === '/declareDefine'){
                if(this.declareList !== ''){
                  this.$router.push({
                    path: "/declareShow",
                    query: {
                      id: this.declareList[0].id
                    }
                  });
                }else {
                  this.$router.push({
                    path: "/declareDefine",
                  });
                }
              }
            });
          }
          this.activityList = [];
          this.$store.state.isLeave = true;
        }).catch(() => {

        });
      } else {
        this.activityValue = '';
        this.declareValue = '';
        setTimeout(() => {
          document.activeElement.blur();
        }, 500);

        if (!this.pageList[pageNum][childPage]) {
          // 展示申报
          this.setFalse(this.pageList);
          this.$store.dispatch("contentChangeDeclareId", "");
          this.pageList[pageNum][childPage] = !this.pageList[pageNum][childPage];
          this.declareList = [];
          if (pageNum === "declare") {
            this.$router.push({
              path: "/declareDefine"
            });
          }
          if (pageNum === "activity") {
            this.$router.push({
              path: "/activityDefine"
            });
            this.$store.dispatch("contentChangeActivityId", "");
            this.activityList = [];
            this.getAllActivityDefine(
                    "/api/blog/eRate/getAllActivityDefine",
                    this.activityList
            ).then(res => {
              if (this.activityList.length > 0) {
                this.goActivity(this.activityList[0].id, 0);
              }
            });
            return;
          }
          this.getAllDeclareDefine(
                  "/api/blog/eRate/getAllDeclareDefine",
                  this.declareList
          ).then(() => {
            this.oldDeclareList = this.declareList;
            if(this.oldDeclareList.length){
              this.showNoData = false
            } else {
              this.showNoData = true
            }
            if (this.declareList.length === 0) {
              this.$router.push({
                path: "/declareDefine",
                query: {
                  id: ""
                }
              });
              return;
            }
            this.$store.dispatch(
                    "contentChangeDeclareId",
                    this.declareList[0].id
            );
            this.declareList[0].change = true;
            // 路由判断
            if(this.$route.path === '/declareDefine'){
              if(this.declareList !== ''){
                this.$router.push({
                  path: "/declareShow",
                  query: {
                    id: this.declareList[0].id
                  }
                });
              }else {
                this.$router.push({
                  path: "/declareDefine",
                });
              }
            }
          });
        }
        this.activityList = [];
      }
    },
    setFalse(obj) {
      Object.keys(obj).forEach(key => {
        if (typeof obj[key] === "object") {
          this.setFalse(obj[key]);
        } else {
          obj[key] = false;
        }
      });
    },
    // 获取所有申报
    getAllDeclareDefine(api, defineArr, key) {
      return this.$https
        .get(api, {
          params: {
            all: true
          }
        })
        .then(res => {
          res.data.forEach(item => {
            defineArr.push({
              name: item.name,
              stateName: this.judge(
                Number(new Date()),
                item.startTime,
                item.endTime
              ),
              id: item.id,
              change: false
            });
          });
        });
    },
    // 获取到所有的活动
    getAllActivityDefine(api, defineArr) {
      // defineArr = [];
      return this.$https
        .get(api, {
          params: {
            all: true
          }
        })
        .then(res => {
          if (!res.data){
            this.isShowActivity = true;
            return;
          }
          this.isShowActivity = false;
          res.data.forEach((item, key) => {
            defineArr.unshift({
              name: item.name,
              state: item.open,
              id: item.id,
              change: false,
              publish: item.publish,
              version: item.version
            });
          });
          this.oldActivityList = defineArr.reverse();
          this.copyList = this.oldActivityList;
        })
        .catch(error => {
          // this.$notify.error({
          //   title: "系统错误"
          // });
        });
    },
    // 判断时间
    judge(currentTime, startTime, endTime) {
      startTime = Number(startTime);
      endTime = Number(endTime);
      if (currentTime < startTime) {
        return "未开始";
      }
      if (currentTime > startTime && currentTime < endTime) {
        return "进行中";
      }
      if (currentTime > endTime) {
        return "已结束";
      } else {
        return '未开始'
      }
    },
    goDeclareShow(key) {
      this.nextKey = key
      this.declareList.forEach(item => {
        item.change = false;
      });
      this.declareList[key].change = true;
      this.$store.dispatch("contentChangeDeclareId", this.declareList[key].id);
      this.$router.push({
        path: "/declareShow",
        query: {
          id: this.declareList[key].id
        }
      });
    },
    goActivity(id, key) {
      this.activityIndex = key;
      this.activityList.forEach(item => {
        item.change = false;
      });
      this.activityList[key].change = true;
      this.activityKey = key;
      let version = this.activityList[key].version;

      this.$store.dispatch("contentChangeActivityId", id, version);
    },
    goActivityClick(id, key) {
      this.activityIndex = key; // 获取选中的索引
      if(!this.$store.state.isLeave){
        this.$confirm('确定离开此页面?离开内容不会保存', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.copyList.forEach(item => {
            item.change = false;
          });
          this.copyList[key].change = true;
          this.activityKey = key;
          let version = this.copyList[key].version;
          this.$store.dispatch("contentChangeActivityId", id, version);
          this.$store.state.isLeave = true;
        }).catch(() => {

        });
      } else {
        this.copyList.forEach(item => {
          item.change = false;
        });
        this.copyList[key].change = true;
        this.activityKey = key;
        let version = this.copyList[key].version;
        this.$store.dispatch("contentChangeActivityId", id, version);
      }

    },
    // 新增申报
    newDeclareDefine() {
      this.declareValue = '';
      setTimeout(() => {
        document.activeElement.blur();
      }, 500);
      this.$router.push({
        path: "/declareDefine",
        query: {
          id: ""
        }
      });
    },
      // 判断页面跳转
      leaveThisPage() {
          this.$confirm('确定离开此页面?离开内容不会保存', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
            this.isLeave = true;
          }).catch(() => {
            this.isLeave = false;
          });
      }
  }
};
</script>
<style lang="scss" scoped>
.teacherControl {
  width: 270px;
  background: #fff;
  box-shadow: 0px 0px 17px 0px rgba(73, 46, 46, 0.02);
  border-radius: 15px;
  overflow: hidden;
  box-sizing: border-box;
  .header {
    .el-button {
      width: 50%;
      height: 64px;
      margin: 0;
      border: 0;
      background: #c8c8c8;
      color: #fff;
      font-size: 20px;
      border-radius: 0;
    }

    .el-button--default {
      width: 50%;
      background: #c8c8c8;
    }
    .el-button--primary {
      width: 50%;
      background: #2196f3;
    }
  }
  .select {
    padding: 20px;
    .el-button--primary {
      width: 100%;
      height: 36px;
      border-radius: 18px;
    }
    .el-input {
      margin-top: 20px;
    }
  }
}
.select-content {
  padding: 0 20px;
  height: 700px;
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: auto;
  .activityItem {
    margin-bottom: 15px;
    cursor: pointer;
    .open,
    .close {
      color: #fff;
      font-size: 12px;
      margin-right: 7px;
      display: inline-block;
      padding: 2px;
      border-radius: 2px;
    }
    .open {
      background: #74b23cff;
    }
    .close {
      background: #ff6363ff;
    }
    .noStart {
      color: #fff;
      margin-right: 7px;
      background: #d8d8d8ff;
    }
    span {
      color: #323333ff;
      font-size: 14px;
      font-weight: bold;
    }
    .active {
      color: #2996f3;
    }
  }
}

.el-button /deep/ span {
  color: #666;
  font-weight: bold;
}
.el-button--primary /deep/ span {
  color: #fff;
  font-weight: bold;
}

.teacherControl /deep/ .select {
  .el-button--primary {
    font-size: 19px;
    padding: 0;
  }
}
</style>
